import React, {useState} from "react";
import {Button, Col, Collapse, Input, Row, Tooltip} from "antd";
import IntlMessage from "../../../../components/util-components/IntlMessage";
import {useTranslation} from "react-i18next";
import {PlusCircleOutlined} from "@ant-design/icons";

const CategoryFilter = ({onSearch, onAdd}) => {
    const [filters, setFilters] = useState({title: ""});
    const {Panel} = Collapse;
    const {t} = useTranslation();

    const handleChange = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value,
        });
    };

    const handleSearch = () => {
        onSearch(filters);
    };
    const handleReset = () => {
        setFilters('');
        onSearch(null);
    };

    return (
        <Collapse accordion style={{width: "100%"}}>
            <Panel
                header={
                    <Row justify="space-between" align="middle">
                        <span>
                           {t("filters")}
                        </span>
                        <Tooltip title={t("category.add")}>
                            <Button className={"ml-3"} type="primary" icon={<PlusCircleOutlined/>} onClick={onAdd}
                                    size="small">
                                <IntlMessage id="category.add"/>
                            </Button>
                        </Tooltip>
                    </Row>
                }
                key="1"
            >
                <Row gutter={[16, 16]}>
                    <Col xs={48} sm={24} md={12}>
                        <Input
                            placeholder={t("title")}
                            name="title"
                            value={filters.title}
                            onChange={handleChange}
                            allowClear
                        />
                    </Col>
                    <Col xs={48} sm={24} md={12}>
                        <Input
                            placeholder={t("description")}
                            name="description"
                            value={filters.description}
                            onChange={handleChange}
                            allowClear
                        />
                    </Col>
                    <Col xs={24} className="text-center">
                        <Button type="primary" onClick={handleSearch}> <IntlMessage id="search"/></Button>
                        <Button type="primary" onClick={handleReset} style={{marginLeft: 8}}> <IntlMessage id="reset"/></Button>
                    </Col>
                </Row>
            </Panel>
        </Collapse>
    );
};

export default CategoryFilter;